import store from "../store"

export const CommonService = {
	showLoading(loading){
		store.commit("SHOW_LOADER", loading);
	},
	showErrorDialog(message){
		store.commit("SHOW_ERROR", message)
	},
	showTextDialog(message, loading){
		store.commit("SHOW_TEXT", message, loading)
	}
};